<template>
    <div>
      <div>
        <div class="main-wrapper">
          <div>
            <!-- <layout-header2></layout-header2> -->
            <layout-header></layout-header>
            <breadcrumb62></breadcrumb62>
            <!-- Page Content -->
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                    <sidebar></sidebar>
                  </div>
  
                  <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                    <loader></loader>
                  </div>
  
                  <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                    <div class="ml-md-4">
                      <b-card no-body>
                        <b-tabs pills card vertical active-nav-item-class="font-weight-bold bg-success text-white">
                          <b-tab active>
                            <template v-slot:title>
                              <span>
                                <span>1. Connect to Your Hospital or Clinic</span>&nbsp;
                                <i style="color: #0d7051;" v-if="associated_hospitals.length !== 0" class="fa fa-check"></i>
                              </span>
                            </template>
                            <b-card-text>
                              <div class="card" style="margin-top: -30px;">
                                <div class="card-body">
                                  <h3>Connect to Your Hospital or Clinic</h3>
                                  <div class="mt-3" style="font-size: 15px;">
                                     <span style=" font-weight: normal;color: rgb(114, 113, 113);">Crucial for
                                        scheduling patient Appointments and Encounters.</span>
                                    <p style="font-weight: bold;color: black;" class="mt-3">Your Hospital/Clinic :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Choose from the existing
                                        list.</span></p>
                                    <p style="font-weight: bold;color: black;">Not listed here : <a class="new_btn btn btn-sm btn-primary" href="/doctor/add-hospital" style="font-size: 12px;">Add New Hospital</a>
                                     </p>
                                  </div>
                                  <!-- Associated With Hospital -->
                                  <form @submit.prevent="Save_Information_Hospital">
                                    <div v-for="(item, index) in associated_hospitals" :key="index">
                                      <!-- {{ associated_hospitals }} -->
                                      <div class="row form-row">
                                        <div class="col-md-7">
                                          <div class="form-group">
                                            <label style="font-size:12px;" v-if="index === 0">Hospital</label>
                                            <v-select class="mr-2" name="name" required="" label="name_of_hospital"
                                              placeholder="Select Hospital" v-model="item.hospital"
                                              :disabled="!isSaveClicked" @input="set_city" :reduce="(option) => option.name"
                                              :options="filteredAssociatedLists[index]" style="font-size:13px;">
                                            </v-select>
                                          </div>
                                        </div>
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <label style="font-size:12px;" v-if="index === 0">City</label>
                                            <input type="text" v-if="item.hospital"
                                              style="border:1px solid rgba(200,200,200,1); width:100%; border-radius:3px; background-color:#f8f8f8; padding:6px; font-size:13px;"
                                              disabled v-model="item.city" />
                                            <input type="text" v-else
                                              style="border:1px solid rgba(200,200,200,1); width:100%; border-radius:3px; background-color:#f8f8f8; padding:6px; font-size:13px;"
                                              disabled v-model="item.city" />
                                          </div>
                                        </div>
                                        <div class="col-md-1" v-if="associated_hospitals.length !== 1">
                                          <div class="form-group" style="cursor: pointer">
                                            <span class="circle" @click="remove_item('associated_hospitals', index)"
                                              v-if="item.hospital === '' || item.city === ''"><i
                                                class="fa fa-times" /></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="add-more">
                                      <a href="javascript:void(0);"
                                        @click="add_Information_hospital('associated_hospitals')" class="add-reg"><i
                                          class="fa fa-plus-circle"></i> {{ associated_hospitals.length === 0 ? 'Add Hospital' : 'Add More' }}</a>
                                    </div>
  
                                    <!-- /Associated With Hospital  -->

                                      <button type="submit" class="new_btn btn btn-sm btn-primary mt-3"
                                        style="font-size:12px;">
                                        Save Changes
                                      </button>
                                
                                  </form>
                                </div>
                              </div>
  
                            </b-card-text>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span>
                                <span>2. Set Up Your Schedules</span> &nbsp;
                                <i style="color: #0d7051;" v-if="practitioner_schedule.length !== 0"
                                  class="fa fa-check"></i>
                              </span>
                            </template>
                            <b-card-text>
                              <div class="card" style="margin-top: -30px;">
                                <div class="card-body">
                                  <h3>Set Up Your Schedules</h3>
                                  <div class="mt-3" style="font-size: 15px;">
                                    <p style="font-weight: bold;color: black;">Choose Hospital/Clinic :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);">
                                        Select each hospital or clinic you're associated with.</span></p>
                                    <p style="font-weight: bold;color: black;"> Define Your Schedule :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Specify slot duration and
                                        your available days and hours.</span></p>
                                    <p style="font-weight: bold;color: black;">Why It Matters :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Patients can seek Online Appointments.</span></p>
                                  </div>
                                  <router-link to="/doctor/schedule-timings">
                                    <button class="new_btn btn btn-sm btn-primary" style="font-size:12px;">Go to Schedule
                                      </button>
                                  </router-link>
                                </div>
                              </div>
                            </b-card-text>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span>
                                <span>3. Online Prescription Setting</span>
                                &nbsp;
                                <i style="color: #0d7051;" v-if="doctor_profile.custom_allow_online_prescsription !== 0"
                                  class="fa fa-check"></i>
                              </span>
                            </template>
                            <b-card-text>
                              <div class="card" style="margin-top: -30px;">
                                <div class="card-body">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <form @submit.prevent="Save_Information_Hospital">
                                        <input type="checkbox" v-model="doctor_profile.custom_allow_online_prescsription"
                                          @change="updatePrescriptionValue" />
                                        <label style="color: black;">Allow Online Prescription</label>
                                        <br/>
                                        <label style="color: black;">Follow Up Days</label>
                              <input type="text" v-model="doctor_profile.custom_follow_up_days
                                " class="form-control" maxlength="4" minlength="4"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                        <div class="submit-section submit-btn-bottom text-left mt-3">
                                          <button type="submit" class="new_btn btn btn-sm btn-primary submit-btn"
                                            style="font-size:12px;">
                                            Save
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                    <div class="form-group">

                            </div>
                                  </div>
                                  <h3>Online Prescription Enables</h3>
                                  <div class="mt-3" style="font-size: 15px;">
                                    <p style="font-weight: bold;color: black;">Utilize Treatment Plans :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Access customizable
                                        treatment plan templates.</span></p>
                                    <p style="font-weight: bold;color: black;">Prescription PDF's On whatsApp :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Patients receive a PDF of
                                        the prescription on whatsApp</span></p>
                                    <p style="font-weight: bold;color: black;">Enhanced Efficiency :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Streamlines the
                                        prescription process, improving patient experience.</span></p>
                                  </div>
                                </div>
                              </div>
                            </b-card-text>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span>
                                <span>4. Setup Treatment Plans</span>
                                &nbsp;
                                <i style="color: #0d7051;" v-if="treatment_plan_details.length !== 0"
                                  class="fa fa-check"></i>
                              </span>
                            </template>
                            <b-card-text>
                              <div class="card" style="margin-top: -30px;">
                                <div class="card-body">
                                  <h3>Setup Treatment Plans</h3>
                                  <p>Before building treatment plans, Following are the essential components to consider</p>
                                  <div class="mt-3" style="font-size: 15px;">
                                    <p style="font-weight: bold;color: black;">Prescription :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Determine if any
                                        medications are necessary to address the patient's condition.
                                      </span>
                                    </p>
                                    <p style="font-weight: bold;color: black;">Investigation :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Specify any additional
                                        diagnostic tests needed for accurate diagnosis or monitoring.</span></p>
                                    <p style="font-weight: bold;color: black;">General Advice :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Outline recommendations for
                                        lifestyle changes, diet, rehabilitation,
                                        or other supportive measures.</span></p>
                                    <p style="font-weight: bold;color: black;">Exercise :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Determine if specific
                                        exercise regimens would benefit the patient's recovery.</span></p>
                                        <p style="font-weight: bold;color: black;">Surgery :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Indicate whether surgery is
                                        required as part of the treatment plan.</span></p>
                                  </div>
                                  <router-link to="/doctor/treatment-plan">
                                    <button class="new_btn btn btn-sm btn-primary" style="font-size:12px;">Go to Treatment Plan
                                      </button>
                                  </router-link>
                                </div>
                              </div>
                            </b-card-text>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span>
                                <span>5. Profile Completion</span>
                                &nbsp; <b-progress :max="max" class="mt-3">
                                  <b-progress-bar variant="warning" :value="values[0]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[1]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[2]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[3]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[4]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[5]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[6]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[7]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[8]"></b-progress-bar>
                                  <b-progress-bar variant="warning" :value="values[9]"></b-progress-bar>
                                </b-progress>
                              </span>
                            </template>
                            <b-card-text>
                              <div class="card" style="margin-top: -30px;">
                                <div class="card-body">
                                  <h3>Profile Completion: Showcase Your Expertise</h3>
                                  <p>Ensure your profile is fully detailed:</p>
                                  <div class="mt-3" style="font-size: 15px;">
                                    <p style="font-weight: bold;color: black;">Complete All Sections :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Fill in every part of your
                                        profile. Patients see how complete your information is.</span></p>
                                    <p style="font-weight: bold;color: black;">Show Your Expertise :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> A complete profile better
                                        informs patients about your qualifications and specialties.</span></p>
                                    <p style="font-weight: bold;color: black;">Patient Trust :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> A detailed profile builds
                                        trust and helps patients choose confidently.</span></p>
                                    <p style="font-weight: bold;color: black;">Why It Matters :<span
                                        style=" font-weight: normal;color: rgb(114, 113, 113);"> Your profile is your first
                                        impression. The more complete it is, the more confidence it instills in potential
                                        patients.</span></p>
                                  </div>
                                  <router-link to="/doctor/profile-settings">
                                    <button class="new_btn btn btn-sm btn-primary" style="font-size:12px;">Go to Profile
                                      </button>
                                  </router-link>
                                </div>
                              </div>
                            </b-card-text>
                          </b-tab>
                        </b-tabs>
                      </b-card>
                      <div class="container p-3 mt-3" style="background-color:#f8f8f8;">
                        <b-tabs active-nav-item-class="font-weight-bold text-white bg-success" content-class="mt-3"
                        align="center">
                        <b-card-group deck>
                          <b-tab title="Training Video in English" active>
                            <div class="container">

                              <div class="row">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">1</span>
                          <img src="@/assets/img/register_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Register a New Doctor</h4>
          <p class="card-description" style="height:130px;">Registration is a must to access the platform for any doctor to use it for his/her patients.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(0)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(0)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">2</span>
                          <img src="@/assets/img/register_patient_by_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Register a New Patient</h4>
          <p class="card-description"  style="height:130px;">If the Patient is not registered in any of supported portal of Smarty Healthcare.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(1)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(1)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">3</span>
                          <img src="@/assets/img/schedule_an_appointment_for_a_patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Schedule an Appointment for a Patient</h4>
          <p class="card-description"  style="height:130px;">Schedule an Appointment as per Patient asked Time or his avaialbility. Patient will be informed in either case.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(2)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(2)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">4</span>
                          <img src="@/assets/img/upload_a_medical_record_by_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Upload a Medical Record</h4>
          <p class="card-description" style="height:130px;">Upload a Medical Record for a Patient. Uploaded Medical Records will be accessible automatically by the Patient.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(3)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(3)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">5</span>
                          <img src="@/assets/img/Record_Vitals_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Record Vitals for a Patient</h4>
          <p class="card-description"  style="height:130px;">Systematic History and Graphical Presentation accessible as a key record of the Patient for Healthcare Monitoring.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(4)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(4)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">6</span>
                          <img src="@/assets/img/Inform_about_leave_absence.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Inform about Leave/Absence</h4>
          <p class="card-description"  style="height:130px;">All Patients will be informed and will be entitled to seek an appointment for the cancelled appointment.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(5)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <!-- <button class="btn btn-white m-1" @click="openVideoPopup(5)"><i class="fas fa-globe"></i> Web App</button> -->
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">7</span>
                          <img src="@/assets/img/Appointment_Listing_and_Encounter_Status.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Appointment Listing and Encounter Status</h4>
          <p class="card-description" style="height:130px;">Empowering Doctors with Access to Scheduled Patient Engagements.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(6)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(5)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">8</span>
                          <img src="@/assets/img/Cancel_an_Appointment_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Cancel an Appointment for a Patient</h4>
          <p class="card-description"  style="height:130px;">Doctor's Ability to Cancel Patient Appointments.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(7)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(6)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">9</span>
                          <img src="@/assets/img/Reschedule_an_Appointment_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Reschedule an Appointment for a Patient</h4>
          <p class="card-description"  style="height:130px;">Empowering Doctors to Reschedule Patient Appointments.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(8)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(7)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">10</span>
                          <img src="@/assets/img/Update_Profile_and_Information.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Update Profile and Information</h4>
          <p class="card-description" style="height:130px;">Seamlessly Update Your Information.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openEngWaVideoPopup(9)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openEngVideoPopup(8)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">11</span>
                          <img src="@/assets/img/Encounter_a_Patient_for_Consultation.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Encounter a Patient for Consultation</h4>
          <p class="card-description"  style="height:130px;">A Comprehensive Doctor-Patient Encounter.</p>
          <div class="card-buttons justify-content-center">
            <!-- <button class="btn btn-white m-1"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button> -->
            <button class="btn btn-white m-1" @click="openEngVideoPopup(9)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">12</span>
                          <img src="@/assets/img/Build_Treatment_Plan_Repository.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Build a Treatment Plan Repository</h4>
          <p class="card-description"  style="height:130px;">Empowering Doctors to Pre-Set Prescriptions and Surgical Interventions.</p>
          <div class="card-buttons justify-content-center">
            <!-- <button class="btn btn-white m-1"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button> -->
            <button class="btn btn-white m-1" @click="openEngVideoPopup(10)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                            </div>
                          </b-tab>
                          <b-tab title="हिंदी में प्रशिक्षण वीडियो">
                            <div class="container">
                            
                              <div class="row">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">1</span>
                          <img src="@/assets/img/register_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">नए डॉक्टर को पंजीकृत करें</h4>
          <p class="card-description" style="height:130px;">किसी भी डॉक्टर के लिए इसका उपयोग उसके/उसके रोगियों के लिए करने के लिए प्लेटफ़ॉर्म तक पहुंचने के लिए पंजीकरण आवश्यक है।</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(0)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(0)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">2</span>
                          <img src="@/assets/img/register_patient_by_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">नए रोगी को पंजीकृत करें</h4>
          <p class="card-description"  style="height:130px;">यदि रोगी Smarty Healthcare के किसी भी समर्थित पोर्टल में पंजीकृत नहीं है</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(1)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(1)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">3</span>
                          <img src="@/assets/img/schedule_an_appointment_for_a_patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">रोगी के लिए एक अपॉइंटमेंट की तिथि तय करें</h4>
          <p class="card-description"  style="height:130px;">रोगी द्वारा पूछे गए समय या उसकी उपलब्धता के अनुसार एक अपॉइंटमेंट की जाएगी। इसके दोनों मामले में रोगी को सूचित किया जाएगा।</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(2)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(2)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">4</span>
                          <img src="@/assets/img/upload_a_medical_record_by_doctor.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">चिकित्सा रेकॉर्ड अपलोड करें</h4>
          <p class="card-description" style="height:130px;">रोगी के लिए एक चिकित्सा रेकॉर्ड अपलोड करें। अपलोड किए गए चिकित्सा रेकॉर्ड्स रोगी द्वारा स्वत: पहुंचने योग्य होंगे।</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(3)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(3)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">5</span>
                          <img src="@/assets/img/Record_Vitals_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">रोगी के लिए वाइटल संकेत दर्ज करें</h4>
          <p class="card-description"  style="height:130px;">रोगी के लिए व्यावसायिक इतिहास और चित्रकृत प्रस्तुति को स्वास्थ्य मॉनिटरिंग के कुंजी रूप में पहुंचाया जाएगा</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(4)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(4)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">6</span>
                          <img src="@/assets/img/Inform_about_leave_absence.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">अवकाश/अनुपस्थिति की सूचना दें</h4>
          <p class="card-description"  style="height:130px;">सभी रोगी को सूचित किया जाएगा और उन्हें रद्द हुई अपॉइंटमेंट के लिए एक अपॉइंटमेंट की मांग करने का अधिकार होगा</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(5)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <!-- <button class="btn btn-white m-1" @click="openVideoPopup(5)"><i class="fas fa-globe"></i> Web App</button> -->
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">7</span>
                          <img src="@/assets/img/Appointment_Listing_and_Encounter_Status.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">अपॉइंटमेंट सूची और संग्रह स्थिति</h4>
          <p class="card-description" style="height:130px;">डॉक्टर्स को निर्धारित रोगी एंगेजमेंट्स तक पहुंचने की शक्ति प्रदान करना</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(6)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(5)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">8</span>
                          <img src="@/assets/img/Cancel_an_Appointment_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">रोगी के लिए एक अपॉइंटमेंट को रद्द करें</h4>
          <p class="card-description"  style="height:130px;">डॉक्टर की क्षमता रोगी की अपॉइंटमेंट को रद्द करने की</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(7)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(6)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">9</span>
                          <img src="@/assets/img/Reschedule_an_Appointment_for_a_Patient.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">रोगी के लिए एक अपॉइंटमेंट को पुनः तय करें</h4>
          <p class="card-description"  style="height:130px;">डॉक्टर्स को रोगी की अपॉइंटमेंट को पुनः तय करने की शक्ति प्रदान करना</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(8)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(7)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">10</span>
                          <img src="@/assets/img/Update_Profile_and_Information.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">प्रोफाइल और जानकारी अपडेट करें</h4>
          <p class="card-description" style="height:130px;">अपनी जानकारी को स्थिति में अपडेट करें</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openWaVideoPopup(9)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button>
            <button class="btn btn-white m-1" @click="openVideoPopup(8)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">11</span>
                          <img src="@/assets/img/Encounter_a_Patient_for_Consultation.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">सलाह के लिए एक रोगी से मुलाकात करें</h4>
          <p class="card-description"  style="height:130px;">एक व्यापक डॉक्टर-रोगी संवाद</p>
          <div class="card-buttons justify-content-center">
            <!-- <button class="btn btn-white m-1" @click="openWaVideoPopup(10)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button> -->
            <button class="btn btn-white m-1" @click="openVideoPopup(9)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">12</span>
                          <img src="@/assets/img/Build_Treatment_Plan_Repository.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">एक उपचार योजना संग्रह का निर्माण करें</h4>
          <p class="card-description"  style="height:130px;">डॉक्टर्स को पूर्व-निर्धारित पर्चियाँ और शल्यक्रियाएं करने की शक्ति प्रदान करना</p>
          <div class="card-buttons justify-content-center">
            <!-- <button class="btn btn-white m-1" @click="openWaVideoPopup(11)"><i class="fab fa-whatsapp" style="font-size: 18px; color:#40c351;"></i> WA Bot</button> -->
            <button class="btn btn-white m-1" @click="openVideoPopup(10)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                            </div>
                          </b-tab>
                        </b-card-group>
                      </b-tabs>
                        <div v-if="isVideoPopupVisible" class="video-popup">
  <span class="close-popup" @click="closeVideoPopup">&times;</span>
  <iframe :src="currentVideoUrl" width="600" height="380" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Page Content -->
            <layout-footer></layout-footer>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import CommonApi from "@/services/CommonApi";
  import config from "../../../services/CommonApi";
  import { mapState } from "vuex";
  const images = require.context("@/assets/img/patients");
  const doctorimages = require.context("@/assets/img/doctors");
  
  export default {
    data() {
      return {
        isVideoPopupVisible: false,
        videoUrls: [
      "https://www.youtube.com/embed/1TSTeHVYuvA?si=Vl-DJ2-nRkJFOxqt",
      "https://www.youtube.com/embed/dsktwcvHr7s?si=hwvPqBPWyULWZQ_i",
      "https://www.youtube.com/embed/cLVgSl7EaTs?si=nJ40ypulJoTGEdWv", 
      "https://www.youtube.com/embed/aoM4wmTW3ms?si=fNn4XuZgUr-YWqvk",
      "https://www.youtube.com/embed/kDdei6MnPAA?si=0i-xUVMaOffmzQ3i",
      "https://www.youtube.com/embed/IiTActAW46I?si=OkDFb1KTwJRsgqD8",
      "https://www.youtube.com/embed/DK97JPsPtJI?si=Yu7vlOrVXQfeGjfz",
      "https://www.youtube.com/embed/VTIoUz1gV8A?si=C1NO8LqomW0wiJG1",
      "https://www.youtube.com/embed/9fvWDbAdrzE?si=8EcmWcPdxmCSYuv2",
      "https://www.youtube.com/embed/FWOiyj4afpM?si=H0yJkfowaFId0G3-",
      "https://www.youtube.com/embed/m8ZQpNF7_sQ?si=EOerW6MutbmGodQO"
    ],

    videoEngUrls: [
      "https://www.youtube.com/embed/SPgCihNQSkw?si=ScvaJt-w0T86gTj2",
      "https://www.youtube.com/embed/7H_YSp1nl4g?si=gEM4VMW7gwzEE2Rv",
      "https://www.youtube.com/embed/pZCixG9iz3s?si=jyRFP9UhJVngN9Ar", 
      "https://www.youtube.com/embed/xar6csPfJ4Q?si=A0GTitHEiJM0YrZX",
      "https://www.youtube.com/embed/8BCGGfdolSw?si=XtM5z9WQegfIaqvy",
      "https://www.youtube.com/embed/brOInFQnWyY?si=K8en4VFVERho92GV",
      "https://www.youtube.com/embed/TxiBYO-Ko-0?si=95qx3yMoDdNjyXtV",
      "https://www.youtube.com/embed/gAZTKXGx8A4?si=CWGgq01X7jmE3cTm",
      "https://www.youtube.com/embed/PdSndtvsBOs?si=Z5SSlBInvoVoFTaC",
      "https://www.youtube.com/embed/C7sraU8uWF4?si=h7qEHBkd8SPi23nW",
      "https://www.youtube.com/embed/8oagcpf6sw0?si=1QcOv_JURaTO_XkL"
    ],

    videoUrls1: [
      "https://www.youtube.com/embed/1fdLkuL69nY?si=1icOT8EyRyzCkgMj",
      "https://www.youtube.com/embed/GC7UTEXJW2k?si=oHGCEsKyxt2bZk87",
      "https://www.youtube.com/embed/fcjrw3NSFDE?si=h1UQMP6s741SBydU", 
      "https://www.youtube.com/embed/stGG1ipjLug?si=Ujx5IVZTu0P4-fvS",
      "https://www.youtube.com/embed/BlyCJugFpoc?si=LF4ozhuy4DC9Alhc",
      "https://www.youtube.com/embed/Uyyibe7ccH4?si=_YzfMAJ5NCAcCo-v",
      "https://www.youtube.com/embed/kgN_jJ9vE08?si=S_Ak9lpEY2xq6-1C",
      "https://www.youtube.com/embed/LBXJ0Yu88W4?si=oa5UKlp4sHnuUOka",
      "https://www.youtube.com/embed/_avFZP2N36E?si=i-MLGZ1QDsWqTENe",
      "https://www.youtube.com/embed/TlH7uYmuBWg?si=23v_o8R5L2i8LUtM"
    ],

        videoEngUrls1: [
      "https://www.youtube.com/embed/-7qbKFJYXM8?si=U4Brci-dCK3OZzIW",
      "https://www.youtube.com/embed/3kJO-SLlqh4?si=lk_nc7APEOD7Uhva",
      "https://www.youtube.com/embed/RnyqKGzxQ_I?si=0L6-WACNmJJZ6B1C", 
      "https://www.youtube.com/embed/ZPQBnXlgGEo?si=0aWeESHqGeb5ikjA",
      "https://www.youtube.com/embed/2sgtIvkv2eU?si=AxacxrDGHWco4TSl",
      "https://www.youtube.com/embed/KVe_A5DFv44?si=-ACpkD23Kr_I17Y7",
      "https://www.youtube.com/embed/suhjYSUeIvg?si=LBMas7fi_t-jFc82",
      "https://www.youtube.com/embed/DVo9bj8F4YU?si=ODjne1PTUhx6njqb",
      "https://www.youtube.com/embed/fkF2kjoDjJo?si=eEcO-MizpISvvqRM",
      "https://www.youtube.com/embed/qsXpBM71dBI?si=KtJdOhzFUnAMGHFq"
    ],


        max: 100,
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        doctor_profile: {
          name: this.user_id,
        },
        total_appointment: 0,
        todays_date: new Date()
          .toString()
          .split(" ")
          .splice(1, 3)
          .join(" "),
        config: config,
        showspinner: true,
        appointments_details: {
          patient_name: "",
          practitioner_name: "",
          appointment_date: "",
          appointment_time: "",
          service_unit: "",
          image: "",
          patient_age: "",
        },
        isSaveClicked: false,
        selectedAssociated: [],
        award_details: [],
        experience_details: [{ hospital_clinic: "", role: "", period_from: "", period_to: "" }],
        modality_charges: [],
        surgery_charges: [],
        doctor_profile: {
          first_name: "",
          middle_name: "",
          last_name: "",
          email_id: "",
          mobile_no: "",
          gender: "",
          date_of_birth: "",
          aadhar_no: "",
          council_registration_number: "",
          healthcare_practitioner_category: "",
          practice_type: "",
          speciality: [],
          custom_follow_up_days:0,
          about_me: "",
          show_charges_at_portal: "",
          name_of_assistant: "",
          assistant_mobile: "",
          assistant_whatsapp: "",
          total_experience_in_years: "",
          address: "",
          city: "",
          state: "",
          suburb: "",
          pincode: "",
          photo_1: "",
          photo_2: "",
          photo_3: "",
          photo_4: "",
        },
  
        ortho_hospitals: [],
        associated_hospitals_invalid: false,
        associated_hospitals: [{ hospital: "", city: "" }],
  
        practitioner_schedule: [],
        treatment_plan_details: [],
      };
    },
    mounted() {

      console.log(this.experience_details)
      let user = localStorage.getItem("userInfo");
      if (!user) {
        this.$router.push({ name: 'login' })
      }
  
      this.User();
      this.get_plan_details();
      this.get_schedule_list_vb();
      this.get_hospital_list();
      this.get_doctor_details();

      $(".progressresult").each(function () {
        const percentageToDegrees = (percentage) => {
          return (percentage / 100) * 360;
        };
        let value = $(this).attr("data-value");
        let left = $(this).find(".progress-left .progress-bar");
        let right = $(this).find(".progress-right .progress-bar");
  
        if (value > 0) {
          if (value <= 50) {
            right.css(
              "transform",
              "rotate(" + percentageToDegrees(value) + "deg)"
            );
          } else {
            right.css("transform", "rotate(180deg)");
            left.css(
              "transform",
              "rotate(" + percentageToDegrees(value - 50) + "deg)"
            );
          }
        }
      });
    },
    computed: {
      
      overallProgress() {
        // Calculate the sum of individual progress values
        const sum = this.values.reduce((acc, value) => acc + value, 0);
  
        // Calculate the overall percentage
        const overallPercentage = (sum / (this.max * this.values.length)) * 100;
  
        // Return the overall percentage
        return Math.round(overallPercentage); // Round to the nearest integer
      },
      filteredAssociatedLists() {
        return this.associated_hospitals.map((item, index) => {
          // Get all selected qualifications from previous dropdowns
          const selectedInPrevious = this.associated_hospitals
            .slice(0, index)
            .map((d) => d.hospital);
          // Return the hospital list excluding the selected ones
          return this.ortho_hospitals.filter(
            (hospital) =>
              !selectedInPrevious.includes(hospital.name) &&
              !this.selectedAssociated.includes(hospital.name)
          );
        });
      },
  
      ...mapState({
        user_id: (state) => state.user.user_id,
        user_type: (state) => state.user.user_type,
      }),
  
    },
  
    methods: {

      openVideoPopup(index) {
    // Open the video popup with the corresponding video URL
    this.isVideoPopupVisible = true;
    this.currentVideoUrl = this.videoUrls[index];
  },

        openEngVideoPopup(index) {
    // Open the video popup with the corresponding video URL
    this.isVideoPopupVisible = true;
    this.currentVideoUrl = this.videoEngUrls[index];
  },

    openEngWaVideoPopup(index) {
    // Open the video popup with the corresponding video URL
    this.isVideoPopupVisible = true;
    this.currentVideoUrl = this.videoEngUrls1[index];
  },

  openWaVideoPopup(index) {
    // Open the video popup with the corresponding video URL
    this.isVideoPopupVisible = true;
    this.currentVideoUrl = this.videoUrls1[index];
  },
  closeVideoPopup() {
    // Close the video popup
    this.isVideoPopupVisible = false;
  },
  
      // treatment plan data
      async get_plan_details() {
        const params = new URLSearchParams();
        params.append("doctor", this.user_id);
        await CommonApi.get_data("sahaj.template.get_plan_details", params).then(
          (res) => {
            this.showspinner = false;
            if (res && res.treatment_plan_name) {
              this.treatment_plan_details = res.treatment_plan_name;
            }
          }
        );
      },
  
      // schedule data
      async get_schedule_list_vb() {
        const params = new URLSearchParams();
        params.append("healthcare_practitioner", this.user_id);
        await CommonApi.get_data(
          "sahaj.appointment.get_schedule_list_vb",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.practitioner_schedule = res.data;
          }
        });
      },
  
      // online prescription
      updatePrescriptionValue() {
        this.doctor_profile.custom_allow_online_prescsription = this.doctor_profile.custom_allow_online_prescsription ? 1 : 0;
      },
      validateForm() {
        if (
          this.new_hospital.name_of_hospital === "" ||
          this.new_hospital.city === ""
        ) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
  
      /* Remove Any Information */
      remove_item(type, id) {
        if (type === "associated_hospitals") {
          this.associated_hospitals.splice(id, 1);
          this.isSaveClicked = false;
        }
      },
  
      Validation_For_associated_hospitals() {
        this.associated_hospitals.some((data) => {
          if (
            data.city === "" ||
            data.hospital === "" ||
            data.city === null ||
            data.hospital === null
          ) {
            this.associated_hospitals_invalid = true;
          } else {
            this.associated_hospitals_invalid = false;
          }
        });
      },
  
  
      Save_Information_Hospital() {
        this.doctor_profile.name = this.user_id;
        this.showspinner = true;
        var data = new FormData();
        data.append("doctor_profile", JSON.stringify(this.doctor_profile));
        data.append("associated_hospitals", JSON.stringify(this.associated_hospitals));
        CommonApi.post_data("sahaj.api.update_doctor_profile_v2", data).then(
          (res) => {
            this.showspinner = false;
            if (res && res.status_code === 200) {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
                showConfirmButton: true,
              }).then(() => {
                // window.location.reload();
                this.get_doctor_details();
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
            this.isSaveClicked = true;
          }
        );
      },
  
      set_city(item) {
        const selectedHospital = this.associated_hospitals.find(
          (hospital) => hospital.hospital === item
        );
        if (selectedHospital) {
          const city = item.split('-')[1];
          selectedHospital.city = city;
        }
      },
  
      /* Get Ortho Hospitals */
      async get_hospital_list() {
        const params = new URLSearchParams();
        //   params.append("type_of_hospital","Ortho Hospital");
        await CommonApi.get_data("sahaj.api.get_hospital_list", params).then(
          (res) => {
            this.ortho_hospitals = res.data;
          }
        );
      },
  
  
      /* Add Any Information */
      add_Information_hospital(type) {
        if (type === "associated_hospitals") {
          this.isSaveClicked = true;
          const allFields = this.associated_hospitals.every(detail =>
            detail.hospital && detail.city
          );
  
          if (this.associated_hospitals.length === 0 || allFields) {
            this.associated_hospitals.push({ hospital: "", city: this.cityData });
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please make sure to select a value from the dropdown menu before adding another one.",
              showConfirmButton: true,
            });
          }
        }
      },
  
  
      User() {
        if (this.user_type !== "doctor") {
          this.$router.push("/patient/index");
        }
      },
  
      loadImg(imgPath) {
        return images("./" + imgPath);
      },
  
      loadDoctorImg(imgPath) {
        return doctorimages("./" + imgPath);
      },
  
      /* Get Doctor Profile Information */
      get_doctor_details() {
        const params = new URLSearchParams();
        params.append("name", this.user_id);
        CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
          if (res && res.data && res.status_code === 200) {
            this.doctor_profile.custom_follow_up_days = res.data.custom_follow_up_days;
            this.associated_hospitals = res.data.associated_hospitals || [];
            this.award_details = res.data.award_details || [];
            this.surgery_charges = res.data.surgery_charges || [];
            this.experience_details = res.data.experience_details || [];
            this.doctor_profile.first_name = res.data.first_name || '';
            this.doctor_profile.email_id = res.data.email || '';
            this.doctor_profile.mobile_no = res.data.mobile_phone || '';
            this.doctor_profile.aadhar_no = res.data.aadhar_no || '';
            this.doctor_profile.council_registration_number = res.data.council_registration_number || '';
            this.doctor_profile.total_experience_in_years = res.data.total_experience_in_years || '';
            const associatedHospitalsProgress = (this.associated_hospitals.length > 0) ? 10 : 0;
            const awardDetailsProgress = (this.award_details.length > 0) ? 10 : 0;
            const surgeryChargesProgress = (this.surgery_charges.length > 0) ? 10 : 0;
            const ExperienceDetails = (this.experience_details.length > 0) ? 10 : 0;
            const DoctorFirstName = (this.doctor_profile.first_name === '') ? 10 : 0;
            const DoctorEmail = (this.doctor_profile.email_id === '') ? 10 : 0;
            const DoctorMobile = (this.doctor_profile.mobile_no === '') ? 10 : 0;
            const DoctorAdharNo = (this.doctor_profile.aadhar_no === '') ? 10 : 0;
            const DoctorCouncilRegNo = (this.doctor_profile.council_registration_number === '') ? 10 : 0;
            const DoctorTotalExp = (this.doctor_profile.total_experience_in_years === '') ? 10 : 0;
  
            this.values[0] = associatedHospitalsProgress;
            this.values[1] = awardDetailsProgress;
            this.values[2] = surgeryChargesProgress;
            this.values[3] = ExperienceDetails;
            this.values[4] = DoctorFirstName;
            this.values[5] = DoctorEmail;
            this.values[6] = DoctorMobile;
            this.values[7] = DoctorAdharNo;
            this.values[8] = DoctorCouncilRegNo;
            this.values[9] = DoctorTotalExp;
  
            this.doctor_profile.first_name = res.data.first_name;
            this.doctor_profile.email_id = res.data.email;
            this.doctor_profile.mobile_no = res.data.mobile_phone;
            this.doctor_profile.aadhar_no = res.data.aadhar_no;
            this.doctor_profile.council_registration_number =
              res.data.council_registration_number;
            this.doctor_profile.total_experience_in_years =
              res.data.total_experience_in_years;
            this.doctor_profile.custom_allow_online_prescsription = res.data.custom_allow_online_prescsription;
            this.associated_hospitals = [];
            (this.experience_details = []),
            this.award_details = [];
            this.surgery_charges = [];

            res.data.associated_hospitals.map((item) =>
              this.associated_hospitals.push({
                hospital: item.hospital,
                city: item.city,
              })
            );
            res.data.experience_details.map((item) =>
            this.experience_details.push({
              hospital_clinic: item.hospital_clinic,
              role: item.role,
              period_from: item.period_from,
              period_to: item.period_to,
            })
          );
            res.data.surgery_charges.map((item) =>
              this.surgery_charges.push({
                surgery_type: item.surgery_type,
                hospital: item.hospital,
                ward_type: item.ward_type,
                charges: item.charges,
              })
            );
            res.data.award_details.map((item) =>
              this.award_details.push({
                award_name: item.award_name,
                year: item.year,
                awarder: item.awarder,
              })
            );
            // if (this.associated_hospitals.length === 0) {
            //   this.$swal.fire({
            //     icon: "warning",
            //     title: "Warning",
            //     text: "Please define Associated Hospital first in the Profile",
            //     showConfirmButton: true,
            //   }).then(() => {
            //     this.$router.push(`/doctor/profile-settings`);
            //   });
            // } else {
            // }
          }
        });
      },
    },
  };
  </script>

<style>

.video-popup {
  display: block;
  position: fixed;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close-popup {
  position: absolute;
  top: 2px;
  right:2px;
  font-size: 30px;
  cursor: pointer;
  color:black;
}

.close-popup:hover {
  color: #ff0000;
}
  .demo-video-card-container {
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensure the container takes full height */
    position: relative;
  }

  .demo-video-card {
    border-radius: 10px;
    background-color: white;
    transition: background-color 0.5s; /* Add a smooth transition effect */
    flex: 1; /* Expand to take remaining space */
  }

  .demo-video-card:hover {
    background-color: #397370;
  }

  .card-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
    transition: background-color 0.5s; /* Add a smooth transition effect */
  }
  .card-buttons button:hover {
    background-color:#66cdaa; /* Change the background color on hover */
    color: white; /* Change the text color on hover */
    transform: scale(1.1); /* Increase the size on hover */
  }

  .demo-video-card-container:hover .card-buttons {
    background-color: rgba(57, 115, 112, 0.8); /* Semi-transparent background on hover */
  }

  .new_btn:hover {
    background-color: #10553e;
  }

  .demo-video-card-container:hover .card-heading,
  .demo-video-card-container:hover .card-description {
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/OnBoarding.vue